// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__xVOAy","shimmer":"style_shimmer__7hMMt","skeleton-loading":"style_skeleton-loading__0E1JU"};